/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Creation/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Creation({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Creation"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let activityAuthorValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'author',
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let activityDateValueData = fromData.useDataFormat({ viewPath,
context: 'activity',
path: 'date',
format: fromFormat.dateShortWithMonth,
})
let constantData = '.'
let aggregateData = fromAggregate.joinNoSpace(activityDateValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Creation.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2e8VY2': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 weight="medium"
 fontSize={dtTypographyFontsizeM}
 lineHeight="16px"
 data="activity.author"
 text={activityAuthorValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 fontSize={dtTypographyFontsizeM}
 lineHeight="16px"
 text="created the task on"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 fontSize={dtTypographyFontsizeM}
 lineHeight="16px"
 data="activity.date"
 format="/Data/format.js dateShortWithMonth"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}